<template>
  <div class="nb-conecta-container py-4 px-3 px-md-4">
    <!-- 1. CABEÇALHO SUPERIOR COM LOGO NB CONECTA E CO-BRANDING -->
    <div class="nb-header-card mb-4">
      <div class="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-3">
        <!-- Lado Esquerdo: Logo NB Conecta + Escritório Contábil -->
        <div class="d-flex flex-wrap align-items-center">
          <div class="nb-logo-wrapper mr-3 mr-lg-4 mb-2 mb-lg-0 pr-lg-4 border-lg-right d-flex align-items-center">
            <img
              src="https://s3.us-east-1.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/logo/nbconecta.png"
              alt="Nota Brasil Conecta"
              class="nb-logo-conecta"
            />
          </div>

          <div class="d-flex align-items-center py-1">
            <img
              v-if="logoContador"
              :src="logoContador"
              class="mr-3 nb-logo-escritorio"
              alt="Logo do Escritório"
            />
            <div v-else class="mr-3 nb-logo-placeholder">
              <i class="fa fa-briefcase"></i>
            </div>
            <div>
              <div class="d-flex align-items-center flex-wrap">
                <h5 class="mb-0 font-weight-bold nb-escritorio-nome">
                  {{ nomeFilial || nomeEscritorio || 'Escritório Contábil' }}
                </h5>
                <span class="badge badge-info-soft ml-2">Painel do Contador</span>
              </div>
              <span class="text-muted small">
                <i class="fa fa-user-circle-o mr-1"></i>
                Responsável: <strong>{{ nomeUsuario }}</strong>
              </span>
            </div>
          </div>
        </div>

        <!-- Lado Direito: Ações de Perfil e Sessão -->
        <div class="d-flex align-items-center flex-wrap gap-2 mt-2 mt-lg-0">
          <button class="btn nb-btn-secondary mr-2" @click="handleEditProfile">
            <i class="fa fa-user mr-1"></i> Editar Perfil
          </button>
          <button class="btn nb-btn-logout" @click="handleLogout">
            <i class="fa fa-sign-out mr-1"></i> Sair
          </button>
        </div>
      </div>
    </div>

    <!-- 2. CARDS DE INDICADORES GERENCIAIS (KPIs NO PADRÃO DO DASHBOARD ERP) -->
    <div class="row mb-4">
      <!-- Total de Clientes -->
      <div class="col-xl-3 col-sm-6 col-12 mb-3 mb-xl-0">
        <div class="dash-kpi-card kpi-accent-0">
          <div class="kpi-top-bar"></div>
          <div class="p-3 d-flex flex-column justify-content-between h-100">
            <div class="d-flex justify-content-between align-items-start">
              <span class="kpi-title">Empresas Clientes</span>
              <div class="kpi-icon-wrapper kpi-icon-bg-0">
                <i class="fa fa-building-o"></i>
              </div>
            </div>
            <div class="mt-2">
              <span class="kpi-value">{{ totalClientes }}</span>
            </div>
            <div class="kpi-meta-footer mt-2 pt-2 text-muted font-11">
              <span><i class="fa fa-database mr-1"></i>Bases ativas no painel</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Certificados Críticos -->
      <div class="col-xl-3 col-sm-6 col-12 mb-3 mb-xl-0">
        <div class="dash-kpi-card kpi-accent-1" :class="{ 'kpi-alert-glow': totalCertificadosCriticos > 0 }">
          <div class="kpi-top-bar" :style="{ background: totalCertificadosCriticos > 0 ? '#ef4444' : '#10b981' }"></div>
          <div class="p-3 d-flex flex-column justify-content-between h-100">
            <div class="d-flex justify-content-between align-items-start">
              <span class="kpi-title">Certificados Críticos</span>
              <div class="kpi-icon-wrapper" :class="totalCertificadosCriticos > 0 ? 'kpi-icon-bg-red' : 'kpi-icon-bg-2'">
                <i class="fa fa-shield"></i>
              </div>
            </div>
            <div class="mt-2">
              <span class="kpi-value" :class="totalCertificadosCriticos > 0 ? 'text-danger' : 'text-success'">
                {{ totalCertificadosCriticos }}
              </span>
            </div>
            <div class="kpi-meta-footer mt-2 pt-2 text-muted font-11">
              <span><i class="fa fa-clock-o mr-1"></i>Expirados ou a vencer em &lt; 30d</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Planos a Vencer -->
      <div class="col-xl-3 col-sm-6 col-12 mb-3 mb-xl-0">
        <div class="dash-kpi-card kpi-accent-2">
          <div class="kpi-top-bar" :style="{ background: totalPlanosRenovacao > 0 ? '#f59e0b' : '#10b981' }"></div>
          <div class="p-3 d-flex flex-column justify-content-between h-100">
            <div class="d-flex justify-content-between align-items-start">
              <span class="kpi-title">Planos a Encerrar</span>
              <div class="kpi-icon-wrapper" :class="totalPlanosRenovacao > 0 ? 'kpi-icon-bg-1' : 'kpi-icon-bg-2'">
                <i class="fa fa-calendar-check-o"></i>
              </div>
            </div>
            <div class="mt-2">
              <span class="kpi-value" :class="totalPlanosRenovacao > 0 ? 'text-warning-dark' : 'text-success'">
                {{ totalPlanosRenovacao }}
              </span>
            </div>
            <div class="kpi-meta-footer mt-2 pt-2 text-muted font-11">
              <span><i class="fa fa-refresh mr-1"></i>Encerramento em &lt; 15 dias</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Clientes 100% Regulares -->
      <div class="col-xl-3 col-sm-6 col-12 mb-3 mb-xl-0">
        <div class="dash-kpi-card kpi-accent-3">
          <div class="kpi-top-bar" style="background: #10b981;"></div>
          <div class="p-3 d-flex flex-column justify-content-between h-100">
            <div class="d-flex justify-content-between align-items-start">
              <span class="kpi-title">Situação Regular</span>
              <div class="kpi-icon-wrapper kpi-icon-bg-2">
                <i class="fa fa-check-circle"></i>
              </div>
            </div>
            <div class="mt-2">
              <span class="kpi-value text-success">{{ totalClientesRegulares }}</span>
            </div>
            <div class="kpi-meta-footer mt-2 pt-2 text-muted font-11">
              <span><i class="fa fa-smile-o mr-1"></i>Sem pendências imediatas</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 3. TOOLBAR: BUSCA RÁPIDA E FILTROS DE STATUS -->
    <div class="nb-toolbar-card mb-4">
      <div class="row align-items-center">
        <!-- Campo de Pesquisa -->
        <div class="col-lg-5 col-md-6 col-12 mb-2 mb-md-0">
          <div class="nb-search-wrapper">
            <i class="fa fa-search nb-search-icon"></i>
            <input
              type="text"
              v-model="filtroTexto"
              class="form-control nb-search-input"
              placeholder="Buscar por razão social, nome ou CNPJ..."
            />
            <button
              v-if="filtroTexto"
              type="button"
              class="btn btn-sm nb-search-clear"
              @click="filtroTexto = ''"
            >
              &times;
            </button>
          </div>
        </div>

        <!-- Filtros Rápidos por Pílulas -->
        <div class="col-lg-7 col-md-6 col-12 d-flex justify-content-md-end align-items-center flex-wrap gap-2">
          <div class="nb-pill-group">
            <button
              class="nb-pill-btn"
              :class="{ active: filtroStatus === 'todos' }"
              @click="filtroStatus = 'todos'"
            >
              Todos ({{ totalClientes }})
            </button>
            <button
              class="nb-pill-btn"
              :class="{ active: filtroStatus === 'cert_critico' }"
              @click="filtroStatus = 'cert_critico'"
            >
              <i class="fa fa-shield text-danger mr-1"></i> Certificados ({{ totalCertificadosCriticos }})
            </button>
            <button
              class="nb-pill-btn"
              :class="{ active: filtroStatus === 'plano_critico' }"
              @click="filtroStatus = 'plano_critico'"
            >
              <i class="fa fa-shopping-cart text-warning mr-1"></i> Planos ({{ totalPlanosRenovacao }})
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 4. TABELA DE EMPRESAS CLIENTES ESTILIZADA -->
    <div class="nb-dash-card">
      <div class="nb-dash-header">
        <div class="d-flex align-items-center">
          <span class="nb-dash-title-text">
            <i class="fa fa-list-alt text-primary mr-2"></i>Carteira de Empresas Clientes
          </span>
          <span class="nb-badge-count ml-2">{{ empresasFiltradas.length }} exibida(s)</span>
        </div>
      </div>

      <div class="p-0 table-responsive">
        <table class="table table-hover nb-table mb-0">
          <thead>
            <tr>
              <th width="32%">Nome / Razão Social</th>
              <th width="16%">CNPJ</th>
              <th width="16%">Email / Contato</th>
              <th width="15%">Plano</th>
              <th width="15%">Certificado Digital</th>
              <th width="6%" class="text-right text-nowrap">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="emp in empresasFiltradas" :key="emp.uuid">
              <td>
                <div class="font-weight-bold text-dark">{{ emp.nome }}</div>
              </td>
              <td>
                <span class="font-mono text-muted font-12">{{ emp.cnpj | formatCNPJCPF }}</span>
              </td>
              <td>
                <span class="text-muted small">{{ emp.email || '-' }}</span>
              </td>
              <td>
                <a
                  v-if="precisaRenovarPlano(emp.data_termino_plano)"
                  @click.prevent="acessarEmpresaParaRenovacao(emp.uuid)"
                  href="#"
                  :class="badgeDataTermino(emp.data_termino_plano)"
                  title="Renovar Plano do Cliente"
                >
                  <i class="fa fa-shopping-cart mr-1"></i>
                  {{ formatarDataTermino(emp.data_termino_plano) }}
                </a>
                <span v-else :class="badgeDataTermino(emp.data_termino_plano)">
                  {{ formatarDataTermino(emp.data_termino_plano) }}
                </span>
              </td>
              <td>
                <a
                  v-if="precisaCertificado(emp.validade_certificado)"
                  href="https://www.notabrasil.com.br/certificado-digital/#plans"
                  target="_blank"
                  rel="noopener noreferrer"
                  :class="badgeCertificado(emp.validade_certificado)"
                  title="Comprar / Renovar Certificado Digital"
                >
                  <i class="fa fa-shield mr-1"></i>
                  {{ formatarData(emp.validade_certificado) }}
                </a>
                <span v-else :class="badgeCertificado(emp.validade_certificado)">
                  {{ formatarData(emp.validade_certificado) }}
                </span>
              </td>
              <td class="text-right text-nowrap">
                <button
                  class="btn nb-btn-action-icon mr-1"
                  @click="consultarEmpresa(emp.uuid)"
                  title="Consultar detalhes cadastrais e filiais"
                >
                  <i class="fa fa-search"></i>
                </button>
                <button
                  class="btn nb-btn-access"
                  @click="acessarEmpresa(emp.uuid)"
                  title="Acessar painel do cliente"
                >
                  <span>Acessar</span>
                  <i class="fa fa-external-link ml-1"></i>
                </button>
              </td>
            </tr>

            <!-- EMPTY STATE QUANDO NADA FOR ENCONTRADO -->
            <tr v-if="empresasFiltradas.length === 0">
              <td colspan="6" class="text-center py-5">
                <div class="nb-empty-state">
                  <i class="fa fa-folder-open-o nb-empty-icon mb-2"></i>
                  <div class="font-weight-bold text-dark">Nenhuma empresa encontrada</div>
                  <small class="text-muted">Ajuste os filtros de pesquisa para visualizar os registros.</small>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 5. COMPONENTE DE FORMULÁRIO DO USUÁRIO EM MODAL -->
    <div v-if="showEditProfile" class="modal nb-modal-mask" style="display:block; z-index: 1050 !important;">
      <div class="modal-dialog modal-dialog-centered modal-full-w" role="document">
        <div class="modal-content modal-full-h nb-modal-content">
          <div class="modal-body p-0">
            <perfil-contador-form
              :index="codusuario"
              crud="upd"
              @closeform="handleCloseProfile"
            ></perfil-contador-form>
          </div>
        </div>
      </div>
    </div>

    <!-- 6. MODAL DE DETALHES DA EMPRESA CLIENTE -->
    <div
      v-if="showClientDetails"
      class="modal nb-modal-mask"
      style="display: block; z-index: 1050 !important; overflow-y: auto;"
    >
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content shadow-lg border-0" style="border-radius: 12px; overflow: hidden;">
          <div class="modal-header bg-white border-bottom py-3 px-4">
            <div class="d-flex align-items-center">
              <div class="nb-modal-header-icon mr-3">
                <i class="fa fa-building"></i>
              </div>
              <div>
                <h5 class="modal-title font-weight-bold text-dark mb-0">Consulta Cadastral do Cliente</h5>
                <small class="text-muted">Visão unificada de cadastro, filiais, plano e utilização</small>
              </div>
            </div>
            <button type="button" class="close" @click="showClientDetails = false">
              <span>&times;</span>
            </button>
          </div>

          <div class="modal-body p-4" style="max-height: 75vh; overflow-y: auto;">
            <div v-if="loadingClientDetails" class="text-center py-5">
              <i class="fa fa-spinner fa-spin fa-3x text-primary"></i>
              <p class="mt-2 text-muted">Carregando dados da empresa...</p>
            </div>

            <div v-else-if="selectedClient">
              <!-- 1. Dados Principais -->
              <div class="card nb-inner-card mb-4">
                <div class="card-header bg-white d-flex justify-content-between align-items-center py-3">
                  <h6 class="mb-0 font-weight-bold text-dark">
                    <i class="fa fa-info-circle mr-2 text-primary"></i>Dados da Empresa Matriz
                  </h6>
                  <button @click="showFullData = !showFullData" class="btn btn-link btn-sm font-weight-bold p-0 text-decoration-none">
                    {{ showFullData ? 'Recolher' : 'Ver todos os dados' }}
                  </button>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-6 mb-3">
                      <span class="d-block font-weight-bold text-muted small text-uppercase">Razão Social</span>
                      <strong class="text-dark">{{ selectedClient.nome }}</strong>
                    </div>
                    <div class="col-md-6 mb-3">
                      <span class="d-block font-weight-bold text-muted small text-uppercase">CNPJ</span>
                      <span class="font-mono">{{ selectedClient.cnpj }}</span>
                    </div>
                    <div class="col-md-6 mb-3 mb-md-0">
                      <span class="d-block font-weight-bold text-muted small text-uppercase">Email</span>
                      <span>{{ selectedClient.email || '-' }}</span>
                    </div>
                    <div class="col-md-6">
                      <span class="d-block font-weight-bold text-muted small text-uppercase">Telefone</span>
                      <span>{{ selectedClient.fone || '-' }}</span>
                    </div>
                  </div>

                  <!-- Expansível: Dados Cadastrais -->
                  <div v-if="showFullData" class="border-top mt-3 pt-3">
                    <h6 class="font-weight-bold text-primary mb-3">Endereço e Cadastro</h6>
                    <div class="row">
                      <div class="col-md-6 mb-3">
                        <span class="d-block font-weight-bold text-muted small text-uppercase">Endereço</span>
                        <span>{{ selectedClient.endereco || '-' }}, {{ selectedClient.numero || '' }} {{ selectedClient.complemento || '' }}</span>
                      </div>
                      <div class="col-md-6 mb-3">
                        <span class="d-block font-weight-bold text-muted small text-uppercase">Bairro / CEP</span>
                        <span>{{ selectedClient.bairro || '-' }} / {{ selectedClient.cep || '-' }}</span>
                      </div>
                      <div class="col-md-4 mb-3">
                        <span class="d-block font-weight-bold text-muted small text-uppercase">Cidade / UF</span>
                        <span>{{ selectedClient.codmun || '-' }} / {{ selectedClient.uf || '-' }}</span>
                      </div>
                      <div class="col-md-4 mb-3">
                        <span class="d-block font-weight-bold text-muted small text-uppercase">Inscrição Estadual</span>
                        <span>{{ selectedClient.ie || '-' }}</span>
                      </div>
                      <div class="col-md-4 mb-3">
                        <span class="d-block font-weight-bold text-muted small text-uppercase">Schema DB</span>
                        <span class="badge badge-info-soft font-mono">{{ selectedClient.dbschema || '-' }}</span>
                      </div>
                      <div class="col-md-6">
                        <span class="d-block font-weight-bold text-muted small text-uppercase">Data Cadastro</span>
                        <span>{{ formatarDataGenerica(selectedClient.dtcadastro) }}</span>
                      </div>
                    </div>

                    <!-- Filiais -->
                    <div class="border-top mt-4 pt-3">
                      <h6 class="font-weight-bold text-primary mb-3">
                        <i class="fa fa-sitemap mr-2"></i>Filiais Cadastradas ({{ selectedClient.filiais ? selectedClient.filiais.length : 0 }})
                      </h6>
                      <div v-if="selectedClient.filiais && selectedClient.filiais.length > 0" class="row">
                        <div v-for="(filial, idx) in selectedClient.filiais" :key="idx" class="col-md-12 mb-3">
                          <div class="card bg-light border-0 p-3 rounded-lg">
                            <div class="row">
                              <div class="col-md-6">
                                <span class="d-block font-weight-bold text-muted small text-uppercase">Razão Social / Fantasia</span>
                                <strong class="text-dark">{{ filial.nome }}</strong>
                                <span class="d-block text-muted small">{{ filial.fantasia }}</span>
                              </div>
                              <div class="col-md-3">
                                <span class="d-block font-weight-bold text-muted small text-uppercase">CNPJ</span>
                                <span class="font-mono">{{ filial.cnpj }}</span>
                              </div>
                              <div class="col-md-3">
                                <span class="d-block font-weight-bold text-muted small text-uppercase">Inscrições</span>
                                <span class="d-block small"><b>IE:</b> {{ filial.iest || '-' }}</span>
                                <span class="d-block small"><b>IM:</b> {{ filial.imun || '-' }}</span>
                              </div>
                              <div class="col-12 border-top mt-2 pt-2">
                                <div class="row">
                                  <div class="col-md-4">
                                    <span class="d-block font-weight-bold text-muted small text-uppercase">Endereço</span>
                                    <span class="small">{{ filial.endereco || '-' }}, {{ filial.numero || '' }} {{ filial.complemento || '' }}</span>
                                    <span class="d-block text-muted small">{{ filial.bairro }} - {{ filial.cep }} - {{ filial.codmun }}/{{ filial.uf }}</span>
                                  </div>
                                  <div class="col-md-4">
                                    <span class="d-block font-weight-bold text-muted small text-uppercase">Contato</span>
                                    <span class="d-block small">{{ filial.email || '-' }}</span>
                                    <span class="d-block small">{{ filial.fone || '-' }}</span>
                                  </div>
                                  <div class="col-md-4">
                                    <span class="d-block font-weight-bold text-muted small text-uppercase">Configurações Tributárias</span>
                                    <span class="d-block small"><b>Regime:</b> {{ getDescricaoCRT(filial.crt) }}</span>
                                    <span class="d-block small"><b>Ambiente NF-e:</b> {{ getDescricaoAmbienteNfe(filial.tpambnfe) }}</span>
                                  </div>
                                </div>
                              </div>
                              <div class="col-12 border-top mt-2 pt-2">
                                <div class="row">
                                  <div class="col-md-3">
                                    <span class="d-block font-weight-bold text-muted small text-uppercase">% PIS</span>
                                    <span class="small">{{ filial.apis !== null && filial.apis !== undefined ? filial.apis + '%' : '-' }}</span>
                                  </div>
                                  <div class="col-md-3">
                                    <span class="d-block font-weight-bold text-muted small text-uppercase">% COFINS</span>
                                    <span class="small">{{ filial.acofins !== null && filial.acofins !== undefined ? filial.acofins + '%' : '-' }}</span>
                                  </div>
                                  <div class="col-md-3">
                                    <span class="d-block font-weight-bold text-muted small text-uppercase">Classif. Trib. IBS/CBS</span>
                                    <span class="small">{{ filial.filialcclass || '-' }}</span>
                                  </div>
                                  <div class="col-md-3">
                                    <span class="d-block font-weight-bold text-muted small text-uppercase">Alíquotas IBS/CBS</span>
                                    <span class="d-block small"><b>IBS UF:</b> {{ filial.aliquotaibsuf !== null && filial.aliquotaibsuf !== undefined ? filial.aliquotaibsuf + '%' : '-' }}</span>
                                    <span class="d-block small"><b>CBS:</b> {{ filial.aliquotacbs !== null && filial.aliquotacbs !== undefined ? filial.aliquotacbs + '%' : '-' }}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else class="text-muted italic small pl-2">Nenhuma filial cadastrada.</div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 2. Plano e Certificado em 2 Colunas -->
              <div class="row">
                <!-- Plano -->
                <div class="col-md-6 mb-4">
                  <div class="card nb-inner-card h-100">
                    <div class="card-header bg-white py-3">
                      <h6 class="mb-0 font-weight-bold text-dark">
                        <i class="fa fa-cube mr-2 text-primary"></i>Plano &amp; Assinatura
                        <span class="badge badge-info-soft ml-2">Apenas Consulta</span>
                      </h6>
                    </div>
                    <div class="card-body">
                      <div class="d-flex justify-content-between mb-2">
                        <span class="text-muted small">App Atual:</span>
                        <strong class="text-dark">{{ selectedClient.app || '-' }}</strong>
                      </div>
                      <div class="d-flex justify-content-between mb-2">
                        <span class="text-muted small">Plano Atual:</span>
                        <strong class="text-dark">{{ selectedClient.codplan ? (selectedClient.codplan + ' - ' + (selectedClient.plan_nome || '')) : '-' }}</strong>
                      </div>
                      <div class="d-flex justify-content-between mb-2">
                        <span class="text-muted small">Período:</span>
                        <span>{{ selectedClient.plan_periodo || 'N/A' }}</span>
                      </div>
                      <div class="d-flex justify-content-between border-top pt-2">
                        <span class="text-muted small">Data de Encerramento:</span>
                        <strong :class="verificarDataExpirada(selectedClient.dataterminoplano) ? 'text-danger' : 'text-success'">
                          {{ formatarDataGenerica(selectedClient.dataterminoplano) }}
                        </strong>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Certificados -->
                <div class="col-md-6 mb-4">
                  <div class="card nb-inner-card h-100">
                    <div class="card-header bg-white py-3">
                      <h6 class="mb-0 font-weight-bold text-dark">
                        <i class="fa fa-shield mr-2 text-primary"></i>Dados do Certificado
                      </h6>
                    </div>
                    <div class="card-body p-0">
                      <div v-if="selectedClient.certificados && selectedClient.certificados.length > 0" class="table-responsive">
                        <table class="table table-sm table-hover mb-0">
                          <thead>
                            <tr>
                              <th>Emitido Para</th>
                              <th>Vencimento</th>
                              <th>Tipo</th>
                              <th>Arquivo</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(cert, idx) in selectedClient.certificados" :key="idx" :class="{'table-danger': verificarDataExpirada(cert.dtval)}">
                              <td class="font-weight-bold">{{ cert.nome }}</td>
                              <td>
                                {{ formatarDataGenerica(cert.dtval) }}
                                <span v-if="verificarDataExpirada(cert.dtval)" class="badge badge-danger-soft ml-1">VENCIDO</span>
                              </td>
                              <td>{{ cert.tpcertificado }}</td>
                              <td class="text-muted small">{{ cert.filename }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div v-else class="text-center py-4 text-muted small">
                        Nenhum certificado encontrado para esta empresa.
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 3. Utilização e Notas -->
              <div class="card nb-inner-card mb-4">
                <div class="card-header bg-white py-3">
                  <h6 class="mb-0 font-weight-bold text-dark">
                    <i class="fa fa-bar-chart mr-2 text-primary"></i>Consumo e Faturamento Fiscal
                  </h6>
                </div>
                <div class="card-body">
                  <div class="row">
                    <!-- Quantidade de Notas -->
                    <div class="col-md-6 mb-3 mb-md-0">
                      <div class="border rounded-lg p-3 text-center bg-light">
                        <span class="d-block font-weight-bold text-muted small text-uppercase mb-2">Quantidade de Notas</span>
                        <div class="row">
                          <div class="col-6 border-right">
                            <h4 class="font-weight-bold text-primary mb-0">{{ selectedClient.nf_month || 0 }}</h4>
                            <small class="text-muted text-uppercase font-weight-bold font-10">Mês Atual</small>
                          </div>
                          <div class="col-6">
                            <h4 class="font-weight-bold text-primary mb-0">{{ selectedClient.nf_year || 0 }}</h4>
                            <small class="text-muted text-uppercase font-weight-bold font-10">Ano Vigente</small>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Faturado (Notas) -->
                    <div class="col-md-6">
                      <div class="border rounded-lg p-3 text-center bg-light">
                        <span class="d-block font-weight-bold text-muted small text-uppercase mb-2">Faturado em Notas</span>
                        <div class="row">
                          <div class="col-6 border-right">
                            <h5 class="font-weight-bold text-primary mb-0 text-truncate" :title="formatarMoeda(selectedClient.nf_vlr_month)">
                              {{ formatarMoeda(selectedClient.nf_vlr_month) }}
                            </h5>
                            <small class="text-muted text-uppercase font-weight-bold font-10">Mês Atual</small>
                          </div>
                          <div class="col-6">
                            <h5 class="font-weight-bold text-primary mb-0 text-truncate" :title="formatarMoeda(selectedClient.nf_vlr_year)">
                              {{ formatarMoeda(selectedClient.nf_vlr_year) }}
                            </h5>
                            <small class="text-muted text-uppercase font-weight-bold font-10">Ano Vigente</small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Espaçador para garantir que o rodapé nunca corte o conteúdo -->
              <div style="height: 40px;"></div>
            </div>

            <!-- Fallback caso nenhum dado seja retornado -->
            <div v-else class="text-center py-5">
              <i class="fa fa-info-circle text-muted fa-3x mb-3"></i>
              <p class="text-muted mb-0">Nenhum dado cadastral encontrado para esta empresa.</p>
            </div>
          </div>
          <div class="modal-footer bg-white border-top py-3 px-4">
            <button class="btn btn-secondary" @click="showClientDetails = false">Fechar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { apiORDSmidia } from '../shared/api-functions';
import PerfilContadorForm from './perfil-contador-form.vue';

export default {
  name: 'contador-empresas',
  components: {
    PerfilContadorForm
  },
  data() {
    return {
      logoContador: null,
      nomeFilial: '',
      codfil: null,
      showEditProfile: false,
      codusuario: null,
      showClientDetails: false,
      loadingClientDetails: false,
      selectedClient: null,
      showFullData: false,
      filtroTexto: '',
      filtroStatus: 'todos'
    };
  },
  computed: {
    empresas() {
      return this.$store.getters.getSessao.listaempresas_contador || [];
    },
    nomeEscritorio() {
      return this.$store.getters.getSessao.empresanome || '';
    },
    nomeUsuario() {
      return this.$store.getters.getSessao.usuarionome || '';
    },
    totalClientes() {
      return this.empresas.length;
    },
    totalCertificadosCriticos() {
      return this.empresas.filter(e => this.precisaCertificado(e.validade_certificado)).length;
    },
    totalPlanosRenovacao() {
      return this.empresas.filter(e => this.precisaRenovarPlano(e.data_termino_plano)).length;
    },
    totalClientesRegulares() {
      return this.empresas.filter(
        e => !this.precisaCertificado(e.validade_certificado) && !this.precisaRenovarPlano(e.data_termino_plano)
      ).length;
    },
    empresasFiltradas() {
      return this.empresas.filter(emp => {
        // Filtro de texto (nome ou cnpj)
        if (this.filtroTexto) {
          const termo = this.filtroTexto.toLowerCase();
          const nomeMatch = emp.nome && emp.nome.toLowerCase().includes(termo);
          const cnpjLimpo = (emp.cnpj || '').replace(/\D/g, '');
          const termoLimpo = termo.replace(/\D/g, '');
          const cnpjMatch = termoLimpo && cnpjLimpo.includes(termoLimpo);
          if (!nomeMatch && !cnpjMatch) return false;
        }

        // Filtro de status
        if (this.filtroStatus === 'cert_critico') {
          return this.precisaCertificado(emp.validade_certificado);
        }
        if (this.filtroStatus === 'plano_critico') {
          return this.precisaRenovarPlano(emp.data_termino_plano);
        }

        return true;
      });
    }
  },
  methods: {
    formatarDataGenerica(dateStr) {
      if (!dateStr) return '-';
      try {
        if (typeof dateStr !== 'string') {
          const d = new Date(dateStr);
          if (!isNaN(d.getTime())) return d.toLocaleDateString('pt-BR');
          return '-';
        }
        const datePart = dateStr.split('T')[0];
        if (datePart.includes('-')) {
          const parts = datePart.split('-');
          if (parts.length === 3) {
            const [year, month, day] = parts;
            return `${day}/${month}/${year}`;
          }
        }
        return datePart || dateStr;
      } catch (e) {
        return '-';
      }
    },
    formatarMoeda(val) {
      const numericVal = parseFloat(val || 0);
      return 'R$ ' + numericVal.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    verificarDataExpirada(dateStr) {
      if (!dateStr) return false;
      try {
        const expiryDate = new Date(dateStr);
        if (isNaN(expiryDate.getTime())) return false;
        return expiryDate < new Date();
      } catch (e) {
        return false;
      }
    },
    async consultarEmpresa(empresaUuid) {
      this.selectedClient = null;
      this.showFullData = false;
      this.showClientDetails = true;
      this.loadingClientDetails = true;
      try {
        const url = this.$store.getters.urlOrds + 'cg/contador/cliente/detalhes';
        const res = await axios.get(url, {
          params: {
            uuid_destino: empresaUuid
          }
        });
        let data = res.data;
        if (typeof data === 'string') {
          try {
            data = JSON.parse(data);
          } catch (e) {
            console.error('Erro ao fazer parse dos dados da empresa:', e);
          }
        }
        if (Array.isArray(data)) {
          data = data[0] || {};
        } else if (data && data.items && Array.isArray(data.items)) {
          data = data.items[0] || {};
        }
        this.selectedClient = data;
      } catch (err) {
        alert('Erro ao buscar detalhes do cliente: ' + (err.response && err.response.data && err.response.data.message ? err.response.data.message : err.message));
        this.showClientDetails = false;
      } finally {
        this.loadingClientDetails = false;
      }
    },
    formatarData(dt) {
      if (!dt) return 'Sem Certificado';
      return new Date(dt).toLocaleDateString('pt-BR');
    },
    precisaCertificado(dt) {
      if (!dt) return true;
      const diff = new Date(dt) - new Date();
      const dias = Math.ceil(diff / (1000 * 60 * 60 * 24));
      return dias < 30;
    },
    precisaRenovarPlano(dt) {
      if (!dt) return false;
      const diff = new Date(dt) - new Date();
      const dias = Math.ceil(diff / (1000 * 60 * 60 * 24));
      return dias < 15;
    },
    async acessarEmpresaParaRenovacao(empresaUuid) {
      try {
        const url = this.$store.getters.urlOrds + 'cg/contador/autologin';
        const res = await axios.post(url, {
          uuid_destino: empresaUuid
        });
        const token = res.data.token_uuid;
        const redirectUrl = window.location.origin + window.location.pathname + '?token_autologin=' + token + '&redirect_to=/minhaconta';
        window.open(redirectUrl, '_blank');
      } catch (err) {
        alert('Erro ao solicitar renovação do plano.');
      }
    },
    badgeCertificado(dt) {
      if (!dt) return 'badge-soft badge-danger-soft';
      const diff = new Date(dt) - new Date();
      const dias = Math.ceil(diff / (1000 * 60 * 60 * 24));
      if (dias < 0) return 'badge-soft badge-danger-soft';
      if (dias < 30) return 'badge-soft badge-warning-soft';
      return 'badge-soft badge-success-soft';
    },
    formatarDataTermino(dt) {
      if (!dt) return 'Sem Prazo';
      return new Date(dt).toLocaleDateString('pt-BR');
    },
    badgeDataTermino(dt) {
      if (!dt) return 'badge-soft badge-secondary-soft';
      const diff = new Date(dt) - new Date();
      const dias = Math.ceil(diff / (1000 * 60 * 60 * 24));
      if (dias < 0) return 'badge-soft badge-danger-soft';
      if (dias < 15) return 'badge-soft badge-warning-soft';
      return 'badge-soft badge-success-soft';
    },
    getDescricaoCRT(crt) {
      const crts = {
        '1': 'Simples Nacional',
        '2': 'Simples Nacional - excesso de sublimite',
        '3': 'Regime Normal',
        '4': 'Simples Nacional - MEI'
      };
      return crts[crt] || crt || '-';
    },
    getDescricaoRegimePisCofins(regime) {
      const regimes = {
        '1': 'Lucro Real (Não-Cumulativo)',
        '2': 'Lucro Presumido (Cumulativo)',
        '3': 'Simples Nacional'
      };
      return regimes[regime] || regime || '-';
    },
    getDescricaoAmbienteNfe(amb) {
      const ambs = {
        '1': 'Produção',
        '2': 'Homologação'
      };
      return ambs[amb] || amb || '-';
    },
    async acessarEmpresa(empresaUuid) {
      try {
        const url = this.$store.getters.urlOrds + 'cg/contador/autologin';
        const res = await axios.post(url, {
          uuid_destino: empresaUuid
        });
        const token = res.data.token_uuid;
        const redirectUrl = window.location.origin + window.location.pathname + '?token_autologin=' + token;
        window.open(redirectUrl, '_blank');
      } catch (err) {
        alert('Erro ao solicitar acesso silencioso.');
      }
    },
    handleLogout() {
      this.$store.dispatch('logout');
      window.location.href = '/';
    },
    handleEditProfile() {
      const sessao = this.$store.getters.getSessao;
      if (sessao && sessao.codusuario) {
        this.codusuario = sessao.codusuario.toString();
        this.showEditProfile = true;
      } else {
        alert('Dados da sessão não carregados. Tente atualizar a página.');
      }
    },
    async loadFilialData() {
      try {
        await this.$store.dispatch('loadFilial', {});
        const filialList = this.$store.getters.getFilialList || [];
        if (filialList.length > 0) {
          const mainFilial = filialList[0];
          this.codfil = mainFilial.codfil;
          this.nomeFilial = mainFilial.nome;
          
          // Carrega o logotipo usando o codfil dinâmico da filial principal
          const sessao = this.$store.getters.getSessao;
          if (sessao && sessao.empresacod && this.codfil) {
            const url = this.$store.getters.urlApp + "logo/download/" + sessao.empresacod + "/" + this.codfil;
            apiORDSmidia(url).then(data => {
              if (data && data.size > 0) {
                const self = this;
                const reader = new window.FileReader();
                reader.readAsDataURL(data);
                reader.onload = function () {
                  self.logoContador = reader.result;
                };
              } else {
                this.logoContador = null;
              }
            }).catch(() => {
              this.logoContador = null;
            });
          }
        }
      } catch (err) {
        console.error('Erro ao carregar dados da filial do contador', err);
      }
    },
    handleCloseProfile() {
      this.showEditProfile = false;
      this.loadFilialData();
    }
  },
  created() {
    this.loadFilialData();
  }
};
</script>

<style scoped>
.nb-conecta-container {
  font-family: 'Plus Jakarta Sans', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #0b1c30;
  max-width: 1440px;
  margin: 0 auto;
}

/* 1. HEADER CARD */
.nb-header-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
}

.nb-logo-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.nb-logo-conecta {
  height: 70px;
  width: 70px;
  object-fit: contain;
  transition: all 0.2s ease;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.05));
}

.nb-logo-escritorio {
  width: 44px;
  height: 44px;
  object-fit: contain;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  padding: 3px;
  background: #ffffff;
}

.nb-logo-placeholder {
  width: 44px;
  height: 44px;
  border-radius: 8px;
  background: #eff4ff;
  color: #004e94;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.nb-escritorio-nome {
  font-size: 16px;
  color: #0b1c30;
  letter-spacing: -0.2px;
}

@media (min-width: 992px) {
  .border-lg-right {
    border-right: 1px solid #e2e8f0;
  }
}

@media (max-width: 768px) {
  .nb-logo-conecta {
    height: 54px;
    width: 54px;
  }
}

/* 2. KPI CARDS */
.dash-kpi-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
  position: relative;
  overflow: hidden;
  min-height: 100px;
  transition: all 0.2s ease;
}

.dash-kpi-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.06);
}

.kpi-top-bar {
  height: 3px;
  width: 100%;
}

.kpi-accent-0 .kpi-top-bar { background: #004e94; }
.kpi-accent-1 .kpi-top-bar { background: #ef4444; }
.kpi-accent-2 .kpi-top-bar { background: #f59e0b; }
.kpi-accent-3 .kpi-top-bar { background: #10b981; }

.kpi-title {
  font-size: 11.5px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.kpi-value {
  font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: #0b1c30;
  letter-spacing: -0.5px;
  line-height: 1.2;
}

.kpi-icon-wrapper {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

.kpi-icon-bg-0 { background: #eff4ff; color: #004e94; }
.kpi-icon-bg-1 { background: #fffbeb; color: #d97706; }
.kpi-icon-bg-2 { background: #ecfdf5; color: #059669; }
.kpi-icon-bg-red { background: #fef2f2; color: #dc2626; }

.kpi-meta-footer {
  border-top: 1px dashed #e2e8f0;
}

.font-11 { font-size: 11px; }
.font-10 { font-size: 10px; }
.font-12 { font-size: 12px; }
.font-mono { font-family: SFMono-Regular, Menlo, Monaco, Consolas, monospace; }

.text-warning-dark { color: #d97706; }

/* 3. TOOLBAR CARD & FILTERS */
.nb-toolbar-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 12px 18px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
}

.nb-search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.nb-search-icon {
  position: absolute;
  left: 12px;
  color: #94a3b8;
  font-size: 13px;
}

.nb-search-input {
  padding-left: 36px;
  padding-right: 32px;
  height: 38px;
  border-radius: 8px;
  border: 1px solid #cbd5e1;
  font-size: 13px;
  transition: all 0.15s ease;
}

.nb-search-input:focus {
  border-color: #004e94;
  box-shadow: 0 0 0 3px rgba(0, 78, 148, 0.1);
}

.nb-search-clear {
  position: absolute;
  right: 8px;
  color: #94a3b8;
  font-size: 16px;
  padding: 0 6px;
  background: transparent;
  border: none;
}

.nb-pill-group {
  display: flex;
  gap: 6px;
}

.nb-pill-btn {
  background: #f8fafc;
  border: 1px solid #cbd5e1;
  color: #475569;
  font-size: 12.5px;
  font-weight: 600;
  padding: 6px 12px;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.nb-pill-btn:hover {
  background: #f1f5f9;
  color: #0b1c30;
}

.nb-pill-btn.active {
  background: #004e94;
  border-color: #004e94;
  color: #ffffff;
}

/* 4. DASH CARD & TABLE */
.nb-dash-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
}

.nb-dash-header {
  padding: 14px 20px;
  border-bottom: 1px solid #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ffffff;
}

.nb-dash-title-text {
  font-size: 14px;
  font-weight: 700;
  color: #0b1c30;
  letter-spacing: -0.2px;
}

.nb-badge-count {
  font-size: 11px;
  font-weight: 600;
  background: #eff4ff;
  color: #004e94;
  padding: 2px 8px;
  border-radius: 12px;
}

.nb-table thead th {
  background: #f8fafc;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid #e2e8f0;
  padding: 12px 16px;
}

.nb-table tbody td {
  padding: 14px 16px;
  vertical-align: middle;
  border-bottom: 1px solid #f1f5f9;
  font-size: 13px;
}

.nb-table tbody tr:hover {
  background-color: #f8fafc;
}

/* SOFT BADGES */
.badge-soft {
  display: inline-flex;
  align-items: center;
  font-size: 11.5px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 6px;
  text-decoration: none !important;
}

.badge-success-soft {
  background: #ecfdf5;
  color: #059669;
  border: 1px solid #a7f3d0;
}

.badge-warning-soft {
  background: #fffbeb;
  color: #d97706;
  border: 1px solid #fde68a;
}

.badge-danger-soft {
  background: #fef2f2;
  color: #dc2626;
  border: 1px solid #fecaca;
}

.badge-info-soft {
  background: #eff4ff;
  color: #004e94;
  border: 1px solid #dce9ff;
}

.badge-secondary-soft {
  background: #f1f5f9;
  color: #64748b;
  border: 1px solid #e2e8f0;
}

/* BUTTONS */
.nb-btn-primary {
  background: #004e94;
  color: #ffffff;
  border: 1px solid #004e94;
  font-weight: 600;
  font-size: 12.5px;
  padding: 6px 12px;
  border-radius: 8px;
  transition: all 0.15s ease;
}

.nb-btn-primary:hover {
  background: #00376c;
  color: #ffffff;
}

.nb-btn-secondary {
  background: #ffffff;
  color: #0b1c30;
  border: 1px solid #cbd5e1;
  font-weight: 600;
  font-size: 12.5px;
  padding: 6px 12px;
  border-radius: 8px;
  transition: all 0.15s ease;
}

.nb-btn-secondary:hover {
  background: #f8fafc;
  border-color: #94a3b8;
}

.nb-btn-logout {
  background: #ffffff;
  color: #dc2626;
  border: 1px solid #fecaca;
  font-weight: 600;
  font-size: 12.5px;
  padding: 6px 12px;
  border-radius: 8px;
  transition: all 0.15s ease;
}

.nb-btn-logout:hover {
  background: #fee2e2;
  color: #b91c1c;
}

.nb-btn-action-icon {
  background: #f1f5f9;
  color: #475569;
  border: 1px solid #e2e8f0;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
}

.nb-btn-action-icon:hover {
  background: #e2e8f0;
  color: #0b1c30;
}

.nb-btn-access {
  background: #004e94;
  color: #ffffff;
  border: 1px solid #004e94;
  font-size: 12px;
  font-weight: 600;
  padding: 6px 12px;
  border-radius: 6px;
  transition: all 0.15s ease;
}

.nb-btn-access:hover {
  background: #00376c;
  color: #ffffff;
}

.nb-empty-state {
  padding: 30px;
}

.nb-empty-icon {
  font-size: 32px;
  color: #cbd5e1;
}

/* MODAL RESTYLING */
.nb-modal-content {
  border-radius: 12px;
  border: none;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  background: #ffffff;
}

.nb-modal-header-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #eff4ff;
  color: #004e94;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}

.nb-inner-card {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/forms/contador-empresas.vue